<template>
  <div
    v-if="show"
    class="board-listing-options"
    :class="{
      'board-listing-options--grid': layout === 'grid',
      'board-listing-options--list': layout === 'list',
    }"
  >
    <NebulaDropdown
      button-type="ellipses"
    >
      <template #content>
        <NebulaDropdownItem
          v-if="showEdit"
          icon="edit"
          :text="$t('Edit')"
          :router-link="editLink"
        />
        <NebulaDropdownItem
          v-if="showDelete"
          data-test-id="board-listing-options__option--delete"
          icon="trash"
          :text="$t('Delete')"
          @dropdown-item-clicked="deleteBoard(board)"
        />
        <NebulaDropdownItem
          v-if="showRestore"
          icon="rotate"
          :text="$t('Restore')"
          @dropdown-item-clicked="restore"
        />
      </template>
    </NebulaDropdown>
  </div>
</template>

<script>
import { mapActions } from 'pinia';
import { NebulaDropdown, NebulaDropdownItem } from '@discoveryedu/nebula-components';
import { bus } from '@/lib/eventBus';
import * as types from '@/lib/constants/store';
import {
  useModalStore,
} from '@/stores';

export default {
  name: 'BoardListingOptions',
  components: {
    NebulaDropdown,
    NebulaDropdownItem,
  },
  props: {
    board: {
      type: Object,
      required: true,
    },
    layout: {
      type: String,
      required: true,
    },
    sidebarFilter: {
      type: String,
      required: true,
    },
  },
  computed: {
    canEdit() {
      return ['admin', 'owner', 'edit'].includes(this.board?.access_level);
    },
    editLink() {
      const id = this.board?.references
        ?.find((r) => r.reference_type === 'asset' && r.reference_subtype === 'head')?.reference_id;
      return `/edit?id=${id}`;
    },
    show() {
      return this.showEdit || this.showDelete || this.showRestore;
    },
    showEdit() {
      return this.canEdit && ['MY_STUDIO', 'SHARED_WITH_ME'].includes(this.sidebarFilter);
    },
    showDelete() {
      return this.sidebarFilter !== 'TRASH' && this.board.state !== 'creation'
        && ['admin', 'owner'].includes(this.board?.access_level);
    },
    showRestore() {
      return this.sidebarFilter === 'TRASH'
        && ['admin', 'owner'].includes(this.board?.access_level);
    },
  },
  methods: {
    ...mapActions(useModalStore, [
      types.OPEN_MODAL,
    ]),
    deleteBoard(board) {
      this[types.OPEN_MODAL]({
        type: 'ConfirmDeleteBoard',
        draft: board,
        successCallback() {
          bus.emit('deleteBoard', board.id);
        },
      });
    },
    restore() {
      this[types.OPEN_MODAL]({
        type: 'ConfirmRestoreCreation',
        creation: this.board,
        successCallback() {
          bus.emit('deleteBoard');
        },
      });
    },
  },
};
</script>

<style lang="stylus">
.board-listing-options {
  &--list {
    inset-inline-end: $nebula-space-2x;
    position: absolute;
    top: $nebula-space-2x;
  }
}
</style>
